import axios from 'axios';
import {errorHandler} from "./libs/lib.js";
const {VUE_APP_ERP_BASE_API} = process.env;

function currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function department() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/department");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function position() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/position");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function group() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/crew/group");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function taxgroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`/crew/taxgroup`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function savepersonalinfo(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.post('/crew/savepersonalinfo', data);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function yourpersonalinformation() {
    return new Promise(async (resolve, reject) => {
        try {
            const {data} = await axios.get('/crew/yourpersonalinformation');
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}


export default {
    currency, department,position,group, taxgroup,savepersonalinfo,yourpersonalinformation
};